export default __webpack_public_path__ + "static/media/CaitlinSabean.21eeda8c.jpg";